export const LOCAL_AUTH_TOKEN = 'auth'
export const gridLicense = 'CompanyName=NY CM LLC-3RD PARTY SW,LicensedGroup=Aura,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-007916,ExpiryDate=14_April_2021_[v2]_MTYxODM1NDgwMDAwMA==d077fd4482ae7b3c8bb15310c74f7895'
export const cookieNameLoginSourceUrl = 'login-url'
export const cookieNameSessionTimeout = 'cp-session-timeout'
export const cookieNameLoginAppCookie = 'login-app'
export const cookieNameLoginAuth = 'okta-user-login'
export const cookieNameLocale = 'locale'
export const cookieNameTheme = 'theme'
export const cookieNameRememberMe = 'oktaLoginRememberMe'
export const cookieNameRedirectUrl = 'redirect-url'
export const cookieRedirectedOnceToDM = 'redirectedOnceToDM'
export const cookieNameAppAutoRedirect = 'app-auto-redirect'
export const cookieSessionTimeout = 'session-timeout'
export const isFrench = language => /^fr\b/.test(language)
export const isEnglish = language => /^en\b/.test(language)
